export enum RiskFactorStatus {
    // No interpretation available for the risk factor
    Unknown,
    // Risk factor is within normal limits - i.e. Erectile Function is normal
    Normal,
    // Risk factor is abnormal - i.e. Erectile Function is abnormal
    Abnormal,
    // Risk factor is positive - i.e. Patient is a smoker, patient drinks
    Positive,
    // Risk factor is negative - i.e. Patient is not a smoker, patient does not drink
    Negative
}
